import { __decorate, __metadata } from "tslib";
import { Component, Emit, Prop, Vue } from "vue-property-decorator";
import { ITeamOperationsFieldDTO } from "@/store/models/client/teamOperations";
/**
 * One Team Operations value: its latest recorded value (text, or chips for comma-separated Tools values)
 * and the field history button.
 */
let TeamOperationsValueCell = /** @class */ (() => {
    var _a;
    let TeamOperationsValueCell = class TeamOperationsValueCell extends Vue {
        get value() {
            return this.field.current ? this.field.current.value : null;
        }
        get chips() {
            if (!this.multi || !this.value || this.value.indexOf(",") === -1) {
                return [];
            }
            return this.value
                .split(",")
                .map((part) => part.trim())
                .filter((part) => !!part);
        }
        openHistory() { }
    };
    __decorate([
        Prop({ required: true }),
        __metadata("design:type", typeof (_a = typeof ITeamOperationsFieldDTO !== "undefined" && ITeamOperationsFieldDTO) === "function" ? _a : Object)
    ], TeamOperationsValueCell.prototype, "field", void 0);
    __decorate([
        Prop({ default: "" }),
        __metadata("design:type", String)
    ], TeamOperationsValueCell.prototype, "label", void 0);
    __decorate([
        Prop({ default: false }),
        __metadata("design:type", Boolean)
    ], TeamOperationsValueCell.prototype, "multi", void 0);
    __decorate([
        Prop({ default: true }),
        __metadata("design:type", Boolean)
    ], TeamOperationsValueCell.prototype, "showHistory", void 0);
    __decorate([
        Emit("history"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], TeamOperationsValueCell.prototype, "openHistory", null);
    TeamOperationsValueCell = __decorate([
        Component({
            name: "TeamOperationsValueCell",
        })
    ], TeamOperationsValueCell);
    return TeamOperationsValueCell;
})();
export default TeamOperationsValueCell;
